<template>
    <v-dialog
        v-model="value"
        persistent
        max-width="518px"
        max-height="658px"
        content-class="bible-form-dialog"
    >
        <edit-form
            :data-gathering="dataGathering"
            @close="this.close"
        />
    </v-dialog>
</template>

<script>
import EditForm from "@/Shared/DathaGatherings/Common/Forms/EditForm";
import DialogMixin from "@/Shared/Dialogs/DialogMixin";

export default {
    name: "EditFormDialog",

    components: {EditForm},

    mixins: [DialogMixin],

    props: {
        dataGathering: {
            type: Object,
            require: true,
        },
    },

    data: () => ({

    }),

    methods: {

    },
}
</script>

<style scoped>

</style>
